// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "plotly" + "." + "c9c7579b6665214a1028" + ".js";
};